import { styled } from '@/styled-system/jsx';

// TypeScript interfaces for component props
export interface TourStatusContainerProps {
  showBorder?: boolean;
  noCenter?: boolean;
  errorBoarder?: boolean;
  isCancel?: boolean;
  isRenderedOnHdp?: boolean;
}

export interface TourIconProps {
  isRenderedOnHdp?: boolean;
}

export interface TourTextButtonProps {
  isCancel?: boolean;
}

// Main container for tour status
export const TourStatusContainer = styled('div', {
  base: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px',
    padding: '25px',
    width: '100%',
  },
  variants: {
    showBorder: {
      true: {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'hpxTeal600',
      },
    },
    noCenter: {
      true: {
        alignItems: 'flex-start',
      },
    },
    errorBoarder: {
      true: {
        backgroundColor: 'hpxRed100',
        borderColor: 'hpxRed400',
      },
    },
    isCancel: {
      true: {
        padding: '2x',
      },
    },
  },
});

// Icon component with responsive sizing
export const TourIcon = styled('img', {
  base: {
    width: '22px',
    height: '22px',
  },
  variants: {
    isRenderedOnHdp: {
      true: {
        width: '28px',
        height: '28px',
      },
    },
  },
});

// Container for icon and text grouping
export const IconAndTextContainer = styled('span', {
  base: {
    display: 'flex',
    gap: '10px',
  },
});

// Container for call-to-action buttons
export const CTAContainer = styled('div', {
  base: {
    paddingTop: '25px',
    display: 'flex',
    flexDirection: 'column',
    md: {
      flexDirection: 'row',
      gap: '3x',
    },
  },
});

// Text button for actions
export const TourTextButton = styled('button', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontWeight: 'bold',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: 'none',
    padding: '0',
    color: 'inherit',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  variants: {
    isCancel: {
      true: {
        marginTop: '1x',
      },
    },
  },
});

// Export variant prop types for TypeScript (if needed in the future)
// These can be added back when RecipeVariantProps is properly available
